import React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import CircularProgress from '@mui/material/CircularProgress'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import styles from './_styles/dataSearchStyle'
import { AutocompleteProps } from './_props/AutocompleteProps'

const useStyles = makeStyles(styles)

/**
 * @description Base autocomplete component
 * @param {string} id
 * @param {string} searchText
 * @param {*} value
 * @param {Function} onAutocompleteChange
 * @param {Function} onSelectedAutocomplete
 * @param {boolean} open
 * @param {Function} setOpen
 * @param {*} identifier
 * @param {Object} options
 * @param {*} loading
 * @param {Object} error
 * @param {string} label
 * @param {boolean} disabled
 * @param {string} variant
 * @param {Function} renderOption
 * @param {Object} className
 * @returns
 */
const TokTokDocAutocomplete = <T,>({
    id,
    searchText,
    value,
    onAutocompleteChange,
    onSelectedAutocomplete,
    open,
    setOpen,
    options,
    loading,
    error,
    label,
    disabled,
    variant,
    renderOption,
    className,
    dataCy,
    clearOnBlur,
    onBlur,
    placeholder = 'Recherche',
}: AutocompleteProps<T>) => {
    const classes = useStyles()

    return (
        <Autocomplete
            id={id}
            freeSolo
            clearOnBlur={clearOnBlur}
            inputValue={searchText}
            value={value}
            onInputChange={onAutocompleteChange}
            onChange={onSelectedAutocomplete}
            open={open}
            data-cy={dataCy}
            onOpen={() => {
                if (setOpen) setOpen(true)
            }}
            onClose={() => {
                if (setOpen) setOpen(false)
            }}
            isOptionEqualToValue={(option, val) => {
                try {
                    return JSON.stringify(option) === JSON.stringify(val)
                } catch {
                    return false
                }
            }}
            getOptionLabel={(option) => (typeof option === 'string' ? option : renderOption(option) || '')}
            filterOptions={(opt) => opt}
            options={options}
            loading={loading}
            disabled={disabled}
            loadingText="Recherche en cours ..."
            noOptionsText="Aucun résultat"
            classes={{
                popper: classes.popper,
                paper: classes.paper,
            }}
            ListboxProps={{
                style: {
                    background: 'transparent !important',
                    borderRadius: '0',
                },
            }}
            renderInput={(params) => (
                <form autoComplete="off">
                    <TextField
                        {...params}
                        id="search-rpps"
                        error={error}
                        className={clsx(classes.gridItemContent, className)}
                        label={label}
                        onBlur={() => {
                            if (onBlur) onBlur()
                        }}
                        InputProps={{
                            ...params.InputProps,
                            error,
                            endAdornment: (
                                <>
                                    {loading ? <CircularProgress size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                            placeholder,
                        }}
                        disabled={disabled}
                        variant={variant || 'standard'}
                    />
                </form>
            )}
        />
    )
}

export default TokTokDocAutocomplete
